function deepExtend(out) {
    var a = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        a[_i - 1] = arguments[_i];
    }
    out = out || {};
    for (var i = 1; i < arguments.length; i++) {
        var obj = arguments[i];
        if (!obj)
            continue;
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] !== null && typeof obj[key] === 'object')
                    out[key] = deepExtend((Array.isArray(obj[key]) && out[key] === undefined) ? [] : out[key], obj[key]);
                else
                    out[key] = obj[key];
            }
        }
    }
    return out;
}
function getParentWithClass(el, c, stopAt) {
    if (el.classList.contains(c))
        return el;
    if (stopAt !== undefined && el.classList.contains(stopAt))
        return undefined;
    if (el.parentElement) {
        return getParentWithClass(el.parentElement, c);
    }
    return undefined;
}
function jQWrapper(elements) {
    var _elements = elements;
    _elements.empty = function () {
        for (var _i = 0, _elements_1 = _elements; _i < _elements_1.length; _i++) {
            var x = _elements_1[_i];
            x.innerHTML = '';
        }
        return this;
    };
    _elements.appendTo = function (selector) {
        for (var i = 0; i < _elements.length; i++) {
            if (selector instanceof HTMLElement) {
                selector.appendChild(_elements[i]);
            }
            else if (typeof (selector) === "string") {
                var parents = document.querySelectorAll(selector);
                for (var i_1 = 0, len = parents.length; i_1 < len; i_1++) {
                    parents[i_1].appendChild(_elements[i_1]);
                }
            }
            else {
                for (var j = 0; j < selector.length; j++) {
                    selector[j].appendChild(_elements[i]);
                }
            }
        }
        return this;
    };
    _elements.append = function (el) {
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].appendChild(el);
        }
        return this;
    };
    _elements.add = function (selector) {
        if (selector !== undefined) {
            if (selector instanceof HTMLElement) {
                _elements.push(selector);
            }
            else {
                for (var i = 0; i < selector.length; i++) {
                    _elements.push(selector[i]);
                }
            }
        }
        return this;
    };
    _elements.css = function (key, value) {
        // TODO: support object instead of just simple keys
        if (value === undefined) {
            if (typeof (key) === "string") {
                if (!_elements.length) {
                    return undefined;
                }
                var computed = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight",
                    "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"];
                if (computed.indexOf(key) < 0) {
                    return _elements[0].style[key];
                }
                return window.getComputedStyle(_elements[0])[key];
            }
            else {
                for (var keyEl in key) {
                    if (!key.hasOwnProperty(keyEl)) {
                        continue;
                    }
                    for (var i = 0; i < _elements.length; i++) {
                        if (["height", "width", "top", "left", "bottom", "right"].indexOf(keyEl) >= 0 && typeof key[keyEl] === "number") {
                            _elements[i].style[keyEl] = key[keyEl] + "px";
                        }
                        else {
                            _elements[i].style[keyEl] = key[keyEl];
                        }
                    }
                }
            }
        }
        for (var i = 0; i < _elements.length; i++) {
            if (["height", "width", "top", "left", "bottom", "right"].indexOf(key) >= 0 && typeof value === "number") {
                _elements[i].style[key] = value + "px";
            }
            else {
                _elements[i].style[key] = value;
            }
        }
        return this;
    };
    _elements.attr = function (key, value) {
        if (value === undefined) {
            return _elements.length ? _elements[0][key] : undefined;
        }
        for (var i = 0; i < _elements.length; i++) {
            _elements[i][key] = value;
        }
        return this;
    };
    _elements.closestClass = function (name, stopAt) {
        var result = jQueryReplacement();
        for (var i = 0; i < _elements.length; i++) {
            var match = getParentWithClass(_elements[i], name, stopAt);
            result.add(match);
        }
        return result;
    };
    _elements.remove = function () {
        for (var i = 0; i < _elements.length; i++) {
            var el = _elements[i];
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        }
    };
    _elements.data = function (name, value) {
        if (_elements.length === 0)
            return undefined;
        if (value === undefined) {
            return _elements[0][name];
        }
        for (var i = 0; i < _elements.length; i++) {
            _elements[i][name] = value;
        }
        return this;
    };
    _elements.html = function (value) {
        if (value === undefined) {
            return _elements.length ? _elements[0].innerHTML : undefined;
        }
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].innerHTML = value;
        }
        return this;
    };
    _elements.text = function (value) {
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].innerText = value;
        }
        return this;
    };
    _elements.height = function (value) {
        if (value === undefined) {
            if (!_elements.length) {
                return undefined;
            }
            var cssHeight = parseInt(_elements[0].style.height);
            if (isNaN(cssHeight)) {
                return _elements[0].offsetHeight;
            }
            else {
                return cssHeight;
            }
        }
        for (var i = 0; i < _elements.length; i++) {
            if (typeof value === "string") {
                _elements[i].style.height = value;
            }
            else {
                //_elements[i].offsetHeight = value;
                _elements[i].style.height = value + "px";
            }
        }
        return this;
    };
    _elements.width = function (value) {
        if (value === undefined) {
            if (!_elements.length) {
                return undefined;
            }
            // let cssHeight = parseInt(_elements[0].style.width);
            // if (isNaN(cssHeight)) {
            return _elements[0].offsetWidth;
            // } else {
            //     return cssHeight;
            // }
        }
        for (var i = 0; i < _elements.length; i++) {
            if (typeof value === "string") {
                _elements[i].style.width = value;
            }
            else {
                //_elements[i].offsetWidth = value;
                _elements[i].style.width = value + "px";
            }
        }
        return this;
    };
    _elements.removeClass = function (name) {
        for (var i = 0; i < _elements.length; i++) {
            if (name.indexOf(' ') > 0) {
                var names = name.split(' ');
                for (var nIdx = 0; nIdx < names.length; nIdx++) {
                    _elements[i].classList.remove(names[nIdx]);
                }
            }
            else {
                _elements[i].classList.remove(name);
            }
        }
        return this;
    };
    _elements.offset = function () {
        if (_elements.length === 0)
            return undefined;
        var el = _elements[0];
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    };
    _elements.children = function () {
        var result = [];
        for (var i = 0; i < _elements.length; i++) {
            for (var cidx = 0; cidx < _elements[i].children.length; cidx++) {
                result.push(_elements[i].children[cidx]);
            }
        }
        return jQWrapper(result);
    };
    _elements.on = function (eventname, fnc) {
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].addEventListener(eventname, fnc);
        }
        return this;
    };
    _elements.toggleClass = function (name, state) {
        for (var i = 0; i < _elements.length; i++) {
            if (state === false || _elements[i].classList.contains(name)) {
                _elements[i].classList.remove(name);
            }
            else if (state === true || !_elements[i].classList.contains(name)) {
                _elements[i].classList.add(name);
            }
        }
        return this;
    };
    _elements.find = function (selector) {
        var result = jQueryReplacement();
        for (var i = 0; i < _elements.length; i++) {
            var found = _elements[i].querySelectorAll(selector);
            for (var j = 0; j < found.length; j++) {
                result.add(found[j]);
            }
        }
        return result;
    };
    _elements.slideDown = function (speed, done) {
        //TODO
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].style.display = '';
        }
        return this;
    };
    _elements.slideUp = function (speed, done) {
        //TODO
        for (var i = 0; i < _elements.length; i++) {
            _elements[i].style.display = 'none';
        }
        return this;
    };
    _elements.addClass = function (name) {
        if (name) {
            {
                for (var i = 0; i < _elements.length; i++) {
                    _elements[i].classList.add(name);
                }
            }
        }
        return this;
    };
    _elements.hasClass = function (name) {
        for (var i = 0; i < _elements.length; i++) {
            if (_elements[i].classList.contains(name))
                return true;
        }
        return false;
    };
    _elements.index = function () {
        var index = 0;
        var node = _elements[0];
        if (!node)
            return -1;
        while ((node = node.previousElementSibling)) {
            index++;
        }
        return index;
    };
    return _elements;
}
var jqueryCreate = function (selector) {
    var elements = [];
    if (typeof selector === "string") {
        if (selector[0] === '<') {
            var tmp = document.createElement("div");
            tmp.innerHTML = selector;
            elements.push(tmp.firstElementChild);
        }
        else {
            var q = document.querySelectorAll(selector);
            if (q) {
                for (var i = 0; i < q.length; i++) {
                    var node = q[i];
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        elements.push(node);
                    }
                }
            }
        }
    }
    else {
        if (selector !== undefined) {
            elements.push(selector);
        }
    }
    return jQWrapper(elements);
};
function each(array, fnc) {
    for (var i = 0; i < array.length; i++) {
        fnc(i, array[i]);
    }
}
function shallowExtend(out) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    out = out || {};
    for (var i = 1; i < arguments.length; i++) {
        if (!arguments[i])
            continue;
        for (var key in arguments[i]) {
            if (arguments[i].hasOwnProperty(key))
                out[key] = arguments[i][key];
        }
    }
    return out;
}
jqueryCreate.deepExtend = deepExtend;
jqueryCreate.each = each;
jqueryCreate.shallowExtend = shallowExtend;
export var jQueryReplacement = jqueryCreate;
